import { t } from "i18next"

export type ISupplyType = '' | 'EXTERNAL' | 'INTERNAL'
/**
 * convertSupplyType
 * 調達区分
 * @param supplyType "" | "EXTERNAL" | "INTERNAL"
 */
export const convertSupplyType = (supplyType: ISupplyType): string => {
  switch (supplyType) {
    case 'EXTERNAL':
      return t('convert.supply_type.external')
    case 'INTERNAL':
      return t('convert.supply_type.internal')
    case '':
      return t('convert.supply_type.no_setting')
    default:
      return t('convert.supply_type.no_setting')
  }
}
/**
 * convertContactOrderStatusTextToId
 * @param status
 */
export const convertContactOrderStatusTextToId = (status: string | undefined): number => {
  switch (status) {
    case 'PENDING':
      return 100
    case 'BACKLOG':
      return 200
    case 'NEGOTIATION':
      return 300
    case 'CANCEL':
      return 400
    case 'ACCEPTED':
      return 500
    case 'IN_PROGRESS':
      return 600
    case 'CLOSED':
      return 1000
    default:
      return 0
  }
}

/**
 * convertContactOrderStatusTextToText
 * @param status
 */
export const convertContactOrderStatusTextToText = (status: string): string => {
  switch (status) {
    case 'PENDING':
      return 'PENDING'
    case 'BACKLOG':
      return 'BACKLOG'
    case 'NEGOTIATION':
      return 'NEGOTIATION'
    case 'CANCEL':
      return 'CANCEL'
    case 'ACCEPTED':
      return 'ACCEPTED'
    case 'IN_PROGRESS':
      return 'IN PROGRESS'
    case 'CLOSED':
      return 'CLOSED'
    default:
      return ''
  }
}


export const convertQuotationStatusText = (isLoadingPort: boolean, isPurchased: boolean, isSold: boolean): string => {
  if (!isLoadingPort) {
    return t('convert.quotation_status.not_available')
  }
  if (isPurchased) {
    return t('convert.quotation_status.purchased')
  }
  if (isSold) {
    return t('convert.quotation_status.sold')
  }
  return t('convert.quotation_status.active')
}

export const convertWishListStatusText = (status?: string, isAvailable?: boolean): string => {
  if (status === 'OrderConfirmed') {
    return t('wish_list.order_confirmed').toUpperCase()
  }
  if (status === 'Available' || isAvailable) {
    return t('wish_list.available').toUpperCase()
  }
  return t('wish_list.waiting').toUpperCase()
}

export const convertWishListCatalystText = (
  stockType?: string,
  withCatalyst?: boolean | null
): string | null => {
  if (stockType !== 'Engine' || withCatalyst == null) {
    return null
  }
  return withCatalyst ? t('wish_list.with_catalyst') : t('wish_list.without_catalyst')
}